import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Edit, CreditCard } from 'lucide-react';

interface DebtorDetailHeaderProps {
  debtor: any;
  debtorId: string;
}

export default function DebtorDetailHeader({ debtor, debtorId }: DebtorDetailHeaderProps) {
  const navigate = useNavigate();

  const getStatusBadge = (status: string) => {
    const styles: Record<string, string> = {
      active: 'bg-green-100 text-green-700',
      blocked: 'bg-red-100 text-red-700',
      inactive: 'bg-gray-100 text-gray-700',
    };
    const labels: Record<string, string> = {
      active: 'Aktif',
      blocked: 'Diblokir',
      inactive: 'Tidak Aktif',
    };
    return (
      <span
        className={`px-3 py-1 rounded-full text-sm font-medium ${styles[status] || styles.inactive}`}
      >
        {labels[status] || 'Tidak Aktif'}
      </span>
    );
  };

  return (
    <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
      <div className="flex items-center gap-4">
        <button
          onClick={() => navigate(-1)}
          className="p-2 hover:bg-gray-100 rounded-lg transition-colors"
        >
          <ArrowLeft className="w-5 h-5" />
        </button>
        <div className="flex items-center gap-4">
          <div className="w-16 h-16 rounded-full bg-amber-100 flex items-center justify-center">
            <span className="text-2xl font-bold text-amber-700">{debtor.full_name?.charAt(0)}</span>
          </div>
          <div>
            <h1 className="text-2xl font-bold text-gray-900">{debtor.full_name}</h1>
            <p className="text-gray-500">CIF: {debtor.cif || '-'}</p>
          </div>
        </div>
      </div>
      <div className="flex items-center gap-3">
        {getStatusBadge(debtor.status)}
        <button
          onClick={() => navigate(`/debtorform?id=${debtorId}`)}
          className="flex items-center gap-2 px-4 py-2 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors"
        >
          <Edit className="w-4 h-4" /> Edit
        </button>
        <button className="flex items-center gap-2 px-4 py-2 bg-amber-600 text-white rounded-lg hover:bg-amber-700 transition-colors">
          <CreditCard className="w-4 h-4" /> Ajukan Kredit
        </button>
      </div>
    </div>
  );
}
